import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
export class QQueryChartMetadata extends QRFC {
  constructor() {
    super();
  }

  InitQueryChartData(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qquerychartmetadata";
  }

  SetParams(orgName, user, jsonData, chartID) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    if (jsonData["settings"]["type"] === "serverchart")
      jsonData["settings"]["breadCrumbs"] = Globals._uiConfig.GetBreadCrumbsEnabled(); // Asks for breadCrumbs from the backend.
    var theData = JSON.stringify(jsonData); // JSON.stringify will delete keys if their values are undefined.
    this.AddEncodedParameter("search", theData);
    this.AddEncodedParameter("chartID", chartID);
  }

  SetParamsExplicit(orgName, user, jsonData, chartID, chartMetadata) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);

    var theData = JSON.stringify(jsonData);
    this.AddEncodedParameter("search", theData);
    this.AddEncodedParameter("chartID", chartID);
    if (chartMetadata) this.AddEncodedParameter("chartMetadata", JSON.stringify(chartMetadata));
  }

  DoTransactionComplete(response, callBackObj) {
    const resp = JSON.parse(response);
    const success = "success" in resp ? resp["success"] : true;
    const chartData = "data" in resp ? JSON.parse(resp["data"]) : null;
    //TODO: Move failure handling elsewhere?

    callBackObj.ChartMetadataResult(success, chartData, resp);
  }
}
